import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ChangeRequests() {
  const [reqs, setReqs] = useState([]);
  const [users, setUsers] = useState([]);
  const [shifts, setShifts] = useState({});

  const load = () => api.get("/change-requests").then((r) => setReqs(r.data));

  useEffect(() => {
    load();
    api.get("/users").then((r) => setUsers(r.data));
  }, []);

  const decide = async (id, decision) => {
    try {
      await api.post(`/change-requests/${id}/decide`, { decision });
      toast.success(decision === "approved" ? "承認しました" : "却下しました");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="space-y-4" data-testid="change-requests-page">
      <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900">シフト変更依頼</h1>
      {reqs.length === 0 && <Card className="p-4 text-sm text-slate-500">変更依頼はありません</Card>}
      {reqs.map((r) => {
        const u = users.find((x) => x.id === r.user_id);
        return (
          <Card key={r.id} className="p-4 bg-white border border-slate-200" data-testid={`change-${r.id}`}>
            <div className="flex justify-between items-start">
              <div>
                <p className="font-semibold text-slate-900">{u?.name || r.user_id}</p>
                <p className="text-sm text-slate-600 mt-1">シフトID: {r.shift_id}</p>
                <p className="text-sm text-slate-700 mt-2">{r.reason}</p>
                {r.new_start_time && (
                  <p className="text-xs text-slate-500 mt-1">希望: {r.new_start_time}〜{r.new_end_time}</p>
                )}
              </div>
              <div className="flex flex-col gap-2 items-end">
                <span className={`text-xs rounded-full px-2 py-0.5 border ${
                  r.status === "pending" ? "bg-yellow-50 text-yellow-700 border-yellow-200" :
                  r.status === "approved" ? "bg-green-50 text-green-700 border-green-200" :
                  "bg-slate-100 text-slate-600 border-slate-200"
                }`}>{r.status}</span>
                {r.status === "pending" && (
                  <div className="flex gap-1">
                    <Button size="sm" data-testid={`approve-${r.id}`} onClick={() => decide(r.id, "approved")} className="bg-green-600 hover:bg-green-700 h-7 text-xs">承認</Button>
                    <Button size="sm" variant="outline" data-testid={`reject-${r.id}`} onClick={() => decide(r.id, "rejected")} className="h-7 text-xs">却下</Button>
                  </div>
                )}
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
